module.exports = __webpack_public_path__ + "img/p4.865b4e24.png";